import { Directive, ElementRef } from '@angular/core';
import { AuthService } from '../../auth/auth.service';
import { FncGroup } from '../../auth/FncGroup';
import { AbstractFncGroupVisibilityDirective } from './AbstractFncGroupVisibilityDirective';

@Directive({
  selector: '[digiresIsItSupport]'
})
export class IsItSupportDirective extends AbstractFncGroupVisibilityDirective {

  constructor(element: ElementRef, authService: AuthService) {
    super(element, [FncGroup.IT_SUPPORT], authService);
  }

}
